// Auth entry point for the app: AWS Cognito via Amplify (managed login).
// Token lifecycle lives in cognitoTokenStore.js, the provider-independent
// user-info cache in userInfoCache.js. All app code imports from THIS module.
export {
    getValidAccessToken,
    performLogout,
} from './cognitoTokenStore';

export { AuthTransientError, isAuthTransientError } from './authErrors';

export {
    getUserId,
    getUserOrgId,
    getUserRole,
    getUserName,
    getUserFavLanguage,
    getUserFavLanguageIsSet,
    getUserRootOrgMember,
    setUserRootOrgMember,
    getCognitoLoginLang,
    roleFromClaims,
    onSessionEstablished,
    setUserFavLanguage,
    setUserFavLanguageIsSet,
    storeUserInfo,
} from './userInfoCache';

// React to sign-outs started in other tabs.
import { installCrossTabLogoutListener } from './cognitoTokenStore';
if (typeof window !== 'undefined') {
    installCrossTabLogoutListener();
}
